import React from 'react'
import { Icon, IconProps, SemanticICONS } from 'semantic-ui-react'
import { Tooltip } from './Tooltip'

interface IProps extends IconProps {
  title: React.ReactNode
  cornerIcon?: SemanticICONS
}

export type TooltipIconProps = IProps

export const TooltipIcon = (props: TooltipIconProps) => {
  const { title, cornerIcon, wide, ...rest } = props

  return (
    <Tooltip
      content={title}
      wide={wide}
      trigger={
        cornerIcon ? (
          <Icon.Group>
            <Icon {...rest} />
            <Icon corner name={cornerIcon} />
          </Icon.Group>
        ) : (
          <Icon {...rest} />
        )
      }
    />
  )
}

TooltipIcon.displayName = 'TooltipIcon'
